import { Collapse, Space } from 'antd';
import React, { useContext, useMemo } from 'react';
import { useMedia } from 'react-use';
import { AppContext } from '../../AppContext';
import { BREAKPOINTS } from '../../common/constants';
import AgencyAnalysis from './components/AgencyAnalysis';
import Overview from './components/Overview';
import ProjectAnalysis from './components/ProjectAnalysis';
import UserAnalysis from './components/UserAnalysis';

const Dashboard = () => {
  const { getCurrentTenant, getTenantUser } = useContext(AppContext);
  const isDesktopViewport = useMedia(`(min-width: ${BREAKPOINTS.desktop}px)`);
  const currentTenant = getCurrentTenant();
  const tenantUser = getTenantUser();
  const tenantId = currentTenant || tenantUser?.tenant?.id;

  const items = useMemo(
    () => [
      {
        key: '1',
        label: <h3>Overview</h3>,
        children: <Overview key={`overview-${tenantId}`} tenantId={tenantId} />,
      },
      {
        key: '2',
        label: <h3>Project Analysis</h3>,
        children: (
          <ProjectAnalysis key={`project-${tenantId}`} tenantId={tenantId} />
        ),
      },
      {
        key: '3',
        label: <h3>User Analysis</h3>,
        children: <UserAnalysis key={`user-${tenantId}`} tenantId={tenantId} />,
      },
      {
        key: '4',
        label: <h3>Team Analysis</h3>,
        children: (
          <AgencyAnalysis key={`agency-${tenantId}`} tenantId={tenantId} />
        ),
      },
    ],
    [tenantId],
  );

  const dashboardContent = useMemo(() => {
    return (
      <>
        {!isDesktopViewport && (
          <>
            <div className="page-header text-primary">Dashboard</div>
          </>
        )}
        {isDesktopViewport ? (
          <Space direction="vertical" size={24} className="width-percent-100">
            <Overview key={`overview-${tenantId}`} tenantId={tenantId} />
            <ProjectAnalysis key={`project-${tenantId}`} tenantId={tenantId} />
            <UserAnalysis key={`user-${tenantId}`} tenantId={tenantId} />
            <AgencyAnalysis key={`agency-${tenantId}`} tenantId={tenantId} />
          </Space>
        ) : (
          <div className="width-percent-100 mb-20 dashboard-wrapper">
            <Collapse
              items={items}
              defaultActiveKey={['1']}
              expandIconPosition="end"
            />
          </div>
        )}
      </>
    );
  }, [tenantId, items, isDesktopViewport]);
  return dashboardContent;
};

export default Dashboard;
